import React from 'react'

function Message() {
  return (
    <div className='text-center'><b>You have no message.</b></div>
  )
}

export default Message